import { skipToken } from '@tanstack/react-query';
import { useMemo } from 'react';
import { sortByDesc } from '../../../shared/utils/sortUtils.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { filterByScrapReason, HandledScrapsFilters } from './handledScrapFilters.ts';


export function useGetOperations(
    filters: HandledScrapsFilters,
    queryFiltersSet: boolean,
) {
    const queryFilters = filters.queryFilters;

    const endDayPlusOne = useMemo(() => {
        if (!queryFilters.endDate) return null;
        const date = new Date(queryFilters.endDate);
        date.setDate(date.getDate() + 1);
        return date;
    }, [queryFilters.endDate]);


    const { data: operationsRaw } = trpc.operations.get.useQuery(
        queryFiltersSet ? {
            isScrapHandled: true,
            ...(queryFilters.partDisplayName && { partDisplayNameSearch: queryFilters.partDisplayName.trim() }),
            ...(queryFilters.orderNumber && { orderNumberSearch: queryFilters.orderNumber.trim() }),
            ...((queryFilters.startDate || endDayPlusOne) &&
                { effectiveTime: { start: queryFilters.startDate, end: endDayPlusOne } }
            ),
        } : skipToken,
        {
            placeholderData: (prev) => prev,
            select: (operations) => sortByDesc([...operations], it => it.effectiveTime),
        }
    );

    const filteredOperations = useMemo(() => {
        if (!operationsRaw || !queryFiltersSet) return null;
        const filtered = filterByScrapReason(operationsRaw, filters.visibleReasons);
        return filtered;
    }, [operationsRaw, queryFiltersSet, filters.visibleReasons]);

    return filteredOperations;
}
